class Huddle {
    private id : string = ""
}

export default Huddle